import { template as _$template } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=font-viewer><div class=font-viewer__section><h4>Atlas</h4><img class=font-viewer__atlas></div><div class=font-viewer__section><h4>Sample</h4><canvas class=font-viewer__sample>`);
import { createEffect, createResource } from "solid-js";
const SAMPLE_TEXT = "THE QUICK BROWN FOX JUMPS 0123456789";
function loadImage(path) {
  return new Promise((resolveImage, reject) => {
    const image = new Image();
    image.onload = () => resolveImage(image);
    image.onerror = () => reject(new Error(`failed to load font atlas ${path}`));
    image.src = `/baked/${path}`;
  });
}

/** Draws `SAMPLE_TEXT` onto `canvas` by blitting each glyph's rect out of the atlas, per its baked metrics. */
function drawSample(canvas, atlas, meta) {
  const glyphByCode = new Map(meta.glyphs.map(glyph => [glyph.code, glyph]));
  let width = 0;
  for (const char of SAMPLE_TEXT) {
    width += (glyphByCode.get(char.charCodeAt(0))?.width ?? meta.fontWidth) + 1;
  }
  canvas.width = Math.max(width, 1);
  canvas.height = meta.fontHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.imageSmoothingEnabled = false;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  let x = 0;
  for (const char of SAMPLE_TEXT) {
    const glyph = glyphByCode.get(char.charCodeAt(0));
    if (glyph) {
      ctx.drawImage(atlas, glyph.x, glyph.y, glyph.width, glyph.height, x, 0, glyph.width, glyph.height);
      x += glyph.width + 1;
    } else {
      x += meta.fontWidth + 1;
    }
  }
}

/** Glyph atlas plus a type-out sample line, rendered onto a canvas by slicing glyph rects straight from the baked metrics. */
export function FontViewer(props) {
  const [atlas] = createResource(() => props.entry.path, loadImage);
  let canvasRef;
  createEffect(() => {
    const image = atlas();
    if (!image || !canvasRef) return;
    drawSample(canvasRef, image, props.entry.meta);
  });
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$2.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.nextSibling;
    var _ref$ = canvasRef;
    typeof _ref$ === "function" ? _$use(_ref$, _el$7) : canvasRef = _el$7;
    _$effect(_p$ => {
      var _v$ = `/baked/${props.entry.path}`,
        _v$2 = `${props.entry.id} atlas`;
      _v$ !== _p$.e && _$setAttribute(_el$4, "src", _p$.e = _v$);
      _v$2 !== _p$.t && _$setAttribute(_el$4, "alt", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}